<template>
  <div>
    <template v-if="showPass">
      <div class="bg-white p-4 shadow-theme rounded-small mt-4">
        <div class="text-small text-theme-black-450 text-center leading-18">
          <div>
            <img src="~@/assets/img/answer/regret.png" alt="" width="132" />
          </div>
          <p>真遗憾，红包与您擦肩而过</p>
          <p>别灰心，进<span class="text-btn" @click="onOpenQrcode">“调研工厂+”</span>公众号，答其他红包问卷。</p>
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="isOpenReward">
        <split-box class="text-center" style="background-color: #ffd7d7">
          <template v-slot:top-content>
            <div>
              <span>恭喜您抽中红包</span>
              <span v-if="enableNetManualAudit">
                <span>，红包将在问卷发布人审核通过后发放</span>
              </span>
            </div>
            <div>
              <span class="text-large-x font-bold text-danger"> {{ awardYuanAmount }}</span>
            </div>
          </template>
          <template v-slot:bottom-content>
            <template v-if="hasUser">
              <template v-if="!allowAwardWithoutFollow || awardYuanAmount < 1">
                <div v-if="enableNetManualAudit" class="text-left">
                  <div class="mb-2">
                    调研工厂 <span class="text-theme" @click="onShowWithdrawal">红包提现</span> 流程：
                  </div>
                  <div>
                    <span>1.点击并关注</span>
                    <span class="text-theme" @click="onWechart">“调研工厂+”</span>
                    <span>公众号</span>
                  </div>
                  <div>
                    <span>2. 等待问卷审核，最迟 72 小时内完成审核</span>
                  </div>
                  <div>
                    <span>3. 问卷审核通过“调研工厂+”公众号给您发放红包到账消息（审核不通过无推送）</span>
                  </div>
                  <div>
                    <span>4. 红包到账后，点击公众号底部菜单“我要提现”进行提现</span>
                  </div>
                </div>
                <div v-else>
                  <span>红包将在15分钟内到账，点击并关注</span>
                  <span class="text-theme" @click="onWechart">“调研工厂+”</span>
                  <span>公众号后，点击公众号底部菜单“我要提现”进行提现。</span>
                </div>
                <div v-if="isBindOtherAnswer">
                  <span>同一用户最多可以领取一次红包</span>
                </div>
              </template>
              <template v-else>
                <div v-if="enableNetManualAudit" class="text-left">
                  <div>
                    请按步骤领红包：
                  </div>
                  <div>
                    <span>1. 等待问卷审核，最迟 72 小时内完成审核</span>
                  </div>
                  <div>
                    <span>2. 问卷审核通过后，红包将自动发放至您的微信零钱中</span>
                  </div>
                  <div>
                    <span>3. 建议您点击关注<span class="text-theme" @click="onWechart">“调研工厂+”</span>公众号，关注后可接收红包到账信息。</span>
                  </div>
                </div>
                <div v-else>
                  <span>红包将在15分钟内自动发放至您的微信零钱中</span>
                </div>
              </template>
            </template>
            <div v-else>
              <span class="text-theme-black-450 text-small">
                点击"
                <span @click="onAward" class="text-btn">领取奖励</span>
                "按步骤领取红包。点击"
                <span @click="onOpenQrcode" class="text-btn">调研工厂+</span>
                "关注公众号，
                <template v-if="enableNetManualAudit"> 审核通过后，您可点击公众号底部菜单“我要提现”进行提现。 </template>
                <template v-else>点击公众号底部菜单“我要提现”进行提现。</template>
              </span>
            </div>
          </template>
        </split-box>
      </template>
      <template v-else>
        <blessing-bag v-if="showBlessingBag" @click="openReward" :blessing-bag="blessingBag" />
        <red-reward-button v-else @click="openReward" />
      </template>
      <!--      <el-button type="text" @click="onAward">领取奖励</el-button>-->
    </template>
  </div>
</template>

<script>
import { busGetters, hasValue,BoundFailedType } from 'dygc'
import ImageView from 'dygc-ui/packages/image/src/image-viewer'
import { createPopup } from '@/assets/js/factory'
import AwardPopup from '@/components/popup/AwardPopup'
import DygcQrCode from '@/components/popup/DygcQrCode'
import SplitBox from '@/components/SplitBox'
import RedRewardButton from '@/components/RedRewardButton'
import OfficialAccount from '@/components/overlay/OfficialAccount'
import BlessingBag from 'components/blessing-bag/BlessingBag'

export default {
  name: 'AnswerAward',
  components: { RedRewardButton, SplitBox, BlessingBag },
  computed: {
    showPass(){
      const lottery = this.$bus.currentAwardData?.bindAward || {}
      const pass = lottery.boundStatus ===3 && lottery.boundFailedType === 2
      return (!this.hasReward) || (this.awardYuanAmount===0 && lottery.boundFailedType !== BoundFailedType.OTHER_EXCESS) || pass
    },
    redEnvelopesType() {
      return this.$bus.survey.otherSetting.redEnvelopesType
    },
    showBlessingBag() {
      return this.redEnvelopesType === 1
    },
    blessingBag() {
      return this.$bus.survey.otherSetting.blessingBag || { list: [], num: 0 }
    },
    awardYuanAmount() {
      const data = this.$bus.currentAwardData || {}
      return data.bindAward?.awardYuanAmount
      // return this.overData?.awardYuanAmount
    },
    isOpenReward(){
      return hasValue(this.awardYuanAmount)
    },
    hasUser() {
      return !!this.$bus.params.accountUserId
    },
    hasReward() {
      return this.$bus.currentAwardData?.hasReward
    },
    allowAwardWithoutFollow() {
      return this.overData?.allowAwardWithoutFollow
    },
    isBindOtherAnswer(){
      const bindAward = this.$bus.currentAwardData?.bindAward || {}
      return bindAward?.boundFailedType === BoundFailedType.OTHER_EXCESS // && this.bindAward.boundStatus===3
    },
    ...busGetters(['award', 'overData', 'enableNetManualAudit'])
  },
  methods: {
    onWechart() {
      createPopup(OfficialAccount)
    },
    onAward() {
      const url = this.$bus.getUrl(2)
      console.log(url)
      createPopup(AwardPopup, {
        isTest: !!this.$bus.params.isTest,
        url,
        needAuditFlag: !!this.enableNetManualAudit
      })
    },
    onOpenQrcode() {
      createPopup(DygcQrCode)
    },
    openReward() {
      const answerData = this.$bus.currentAnswerData || {}
      if(answerData.needAccountUserId && !this.$bus.params.accountUserId) {
        this.onAward()
      }else {
        this.$bus.openLoading()
        this.$bus.drawRewards().then((res)=>{
          // this.$bus.overData.awardYuanAmount = res.data.awardYuanAmount
          // this.$bus.currentAnswerData.bindAward = res.data
          this.$bus.currentAwardData.bindAward = res.data
        }).finally(()=>{
          this.$bus.closeLoading()
        })
      }
    },
    onShowWithdrawal(){
      const vm = createPopup(ImageView, {
        zIndex: 3000,
        initialIndex: 0,
        urlList: ["https://wenjuanba-pro.oss-cn-beijing.aliyuncs.com/195967/image/2023-7-3/1688391327893crty_aaa.png?Expires=2023855333&OSSAccessKeyId=LTAI5tRH5yapgQhwWoNXMYrQ&Signature=7G0vjMq31MgaYfCJmvJafIDuXBo%3D"],
        onClose: () => {
          vm.$emit('close')
        }
      })
    }
  }
}
</script>
